<template>
  <svg class="svg-icon" aria-hidden="true" :style="style">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('../assets/svg', false, /\.svg$/);
requireAll(req);
export default {
  name: 'BaseIcon',
  props: {
    name: {
      type: String,
      required: true,
    },
    width: Number,
    height: Number,
  },
  computed: {
    iconName() {
      return `#icon-${this.name}`;
    },
    style() {
      if (this.width && this.height) {
        let style = `height:${this.height}px;width:${this.width}px;`
        return style
      } else {
        return ''
      }
    },
  },
};
</script>

<style>
.svg-icon {
  width: 100%;
  height: 100%;
  fill: currentColor;
  overflow: hidden;
  vertical-align: top;
}
</style>
